<template>
  <div class="auth-page d-flex justify-content-center align-items-center">
    <mdb-container>
      <mdb-card style="width: 100%;">
        <mdb-card-header color="dark">Activate your accoount</mdb-card-header>
        <mdb-card-body class="w-100">
          <div class="d-flex justify-content-center mt-5" v-if="isLoading">
            <div class="spinner-grow text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <mdb-alert
            v-if="showAlert && !isLoading"
            class="d-flex justify-content-center"
            color="danger"
          >
            <b>Oh no,</b> something didnt work. Please try again later.
          </mdb-alert>
        </mdb-card-body>
      </mdb-card>
    </mdb-container>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbContainer,
  mdbAlert,
} from "mdbvue";

export default {
  name: "Login",
  components: {
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbContainer,
    mdbAlert,
  },
  data() {
    return {
      showAlert: false,
    };
  },
  computed: {
    isLoading: function() {
      return this.$store.getters["ui/isLoading"];
    },
  },
  methods: {
    activate: function() {
      this.$store.commit("ui/is_loading", true);
      let urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token");
      this.$store
        .dispatch("user/activate", token)
        .then(() => {
          this.$store.commit("ui/is_loading", false);
          this.$router.push("/login");
        })
        .catch(() => {
          this.$store.commit("ui/is_loading", false);
          this.showAlert = true;
        });
    },
  },
  mounted: function() {
    this.activate();
  },
};
</script>
